import React from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
const DeviceDetail = () => {
  const { t } = useTranslation();
  const initialValues = {
    name: "",
    type: "",
    home: "",
    room: "",
  };

  const submitForm = () => {};

  const validationSchema = Yup.object({
    name: Yup.string().required(t("نام دستگاه را وارد کنید.")),
    type: Yup.string().required(t("نوع دستگاه را وارد کنید.")),
    home: Yup.string().required(t("نام خانه را وارد کنید.")),
    room: Yup.string().required(t("نام اتاق را وارد کنید.")),
  });

  return (
    <>
      <div className="d-flex align-items-start justify-content-between mt-3">
        <p className="m-0 cursor deactive text-center text-white fn12 py-2">
          {t("غیرفعال")}
        </p>
        <div className="deviceDetailsImg">
          <span className="rounded-circle mx-auto mt-2 d-block"></span>
        </div>
        <span className="d-block saveDetails bg-white text-center rounded-circle">
          <i className="icon-ok text-green"></i>
        </span>
      </div>
      <Formik
        initialValues={initialValues}
        onSubmit={submitForm}
        validationSchema={validationSchema}
      >
        {(props) => (
          <Form>
            <div className="my-4">
              <div className="inputs d-flex flex-column justify-content-center w-100 p-1">
                {props.values.name && (
                  <p className="fn12 m-0 text-right">{t("نام دستگاه")}</p>
                )}
                <input
                  type="text"
                  placeholder={t("نام دستگاه")}
                  name="name"
                  className="w-100 text-center fn12"
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                />
              </div>
              <ErrorMessage name="name">
                {(errMsg) => (
                  <div className="text-danger text-right fn10 mt-1">
                    {errMsg}
                  </div>
                )}
              </ErrorMessage>
            </div>
            <div className="my-4">
              <div className="inputs d-flex flex-column justify-content-center w-100 p-1">
                {props.values.type && (
                  <p className="fn12 m-0 text-right">{t("نوع دستگاه")}</p>
                )}
                <input
                  type="text"
                  placeholder={t("نوع دستگاه")}
                  name="type"
                  className="w-100 text-center fn12"
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                />
              </div>
              <ErrorMessage name="type">
                {(errMsg) => (
                  <div className="text-danger text-right fn10 mt-1">
                    {errMsg}
                  </div>
                )}
              </ErrorMessage>
            </div>
            <div className="my-4">
              <div className="inputs d-flex flex-column justify-content-center w-100 p-1">
                {props.values.home && (
                  <p className="fn12 m-0 text-right">{t("خانه")}</p>
                )}
                <input
                  type="text"
                  placeholder={t("خانه")}
                  name="home"
                  className="w-100 text-center fn12"
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                />
              </div>
              <ErrorMessage name="home">
                {(errMsg) => (
                  <div className="text-danger text-right fn10 mt-1">
                    {errMsg}
                  </div>
                )}
              </ErrorMessage>
            </div>
            <div className="my-4">
              <div className="inputs d-flex flex-column justify-content-center w-100 p-1">
                {props.values.room && (
                  <p className="fn12 m-0 text-right">{t("اتاق")}</p>
                )}
                <input
                  type="text"
                  placeholder={t("اتاق")}
                  name="room"
                  className="w-100 text-center fn12"
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                />
              </div>
              <ErrorMessage name="room">
                {(errMsg) => (
                  <div className="text-danger text-right fn10 mt-1">
                    {errMsg}
                  </div>
                )}
              </ErrorMessage>
            </div>
            <div className="my-4">
              <p className="fn12 text-right">{t("انتخاب آیکون")}</p>
              <span className="selectIcon d-block"></span>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export { DeviceDetail };
